var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationMessage = function SvgGeneralInformationMessage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4C4C4C",
    fillRule: "evenodd",
    d: "m20.302 11.983 2.113 2.113-6.735 6.725-2.466-2.456H1.5V5.638h11.714l2.46-2.45 6.738 6.728zm-.023-2.077-6.774 6.632-4.555-4.536 6.723-6.695zM4.066 7.138l3.821 3.805 3.82-3.805zm2.758 4.864L3 15.81V8.194zm12.405 1.03-4.662 4.564 1.111 1.107 4.615-4.608zm-11.342.028-3.82 3.805h7.64z",
    clipRule: "evenodd"
  })));
};
export default SvgGeneralInformationMessage;